// extracted by mini-css-extract-plugin
export default {"pageHeader":"CollectionPageHeader__pageHeader-f8Kf","pageVrmWrapper":"CollectionPageHeader__pageVrmWrapper-N8e_","helpIconWrapper":"CollectionPageHeader__helpIconWrapper-XT_v"};